"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getFilterableMailListContextMenuItems_1 = require("./getFilterableMailListContextMenuItems");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/components/ContextualMenu");
var MailListItemContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemContextMenu, _super);
    function MailListItemContextMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailListItemContextMenu.prototype.render = function () {
        var anchorPoint = this.props.anchorPoint;
        // filter the menu items based on the should show behavior
        var validItems = getFilterableMailListContextMenuItems_1.default(this.props.rowKeys, this.props.tableViewId).filter(function (item) { return item.shouldShow(); });
        return (React.createElement(ContextualMenu_1.ContextualMenu, { shouldFocusOnMount: true, targetPoint: anchorPoint, useTargetPoint: true, directionalHint: 4 /* bottomLeftEdge */, onDismiss: this.props.onDismiss, items: validItems, calloutProps: { preventDismissOnScroll: true } }));
    };
    MailListItemContextMenu = tslib_1.__decorate([
        mobx_react_1.observer
    ], MailListItemContextMenu);
    return MailListItemContextMenu;
}(React.Component));
exports.default = MailListItemContextMenu;
//# sourceMappingURL=MailListItemContextMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-list-context-menu/lib/components/MailListItemContextMenu.js
// module id = 6020
// module chunks = 81